<template>
  <div class="body">
    <div style="margin: 0 auto; max-width: 90vw">
      <el-row :gutter="40" style="margin: 0px; width: 100%">
        <el-col :md="$store.getters.isLoggedIn ? 10 : 8">
          <el-alert
            style="border-radius: 10px"
            title="Información importante"
            type="warning"
            class="intermitente_login"
          >
            <template>
              <small>
                <!-- <p>
                  Estimados Usuarios, les informamos que solo tendrán acceso al "Dashboard General" los usuarios que
                  cuenten con una cuenta de acceso a nuestra plataforma.
                  <br /><br />
                  En caso de que usted trabaje con los inventarios de riesgos y reportes del "Dashboard General" y no
                  cuente con una cuenta de acceso, puede ponerse en contacto con el equipo de soporte.
                  <br /><br />
                  +56 9 9022 5668 (Operativo)
                  support@safetyclub.zendesk.com
                  <br /><br />
                  Horario atención telefónica y chat: Lunes a Viernes de 9:00 a 18:30
                </p> -->
                <p style="line-height: 16px">
                  A partir de este momento, la plataforma Inventario de Riesgos
                  cuenta con un sistema de doble autenticación. Esta medida
                  tiene como objetivo reforzar la seguridad y proteger la
                  confidencialidad de las cuentas de acceso de todos nuestros
                  usuarios que ingresan a nuestros sitios web.
                  <br /><br />
                  <b>¿Cómo funciona la doble autenticación?</b><br /><br />
                  El proceso de doble autenticación funciona de la siguiente
                  manera: Al ingresar su usuario y contraseña, seleccionar el
                  reCAPTCHA y presionar “Iniciar sesión”, la plataforma enviará
                  un código de verificación al correo electrónico registrado en
                  nuestro sistema. Deberá revisar su bandeja de entrada (y, si
                  es necesario, la carpeta de spam), copiar el código recibido e
                  ingresarlo en el campo correspondiente que aparecerá en la
                  plataforma para completar el inicio de sesión.
                  <br /><br />
                  Si no ha recibido el correo con el código de autenticación
                  para validar su acceso al sistema y necesita verificar la
                  dirección de correo registrada en la plataforma, puede ponerse
                  en contacto con el equipo de soporte de la plataforma
                  Inventario de Riesgos de BHP."
                  <br /><br />
                  +56 9 9022 5668 (Operativo)<br />
                  support@safetyclub.zendesk.com
                  <br /><br />
                  <b>Horario atención telefónica y chat:</b><br />Lunes a
                  Viernes de 9:00 a 18:30
                </p>
              </small>
            </template>
          </el-alert>
          <br />
          <el-alert
            style="border-radius: 10px"
            title="Información importante"
            type="warning"
            class="intermitente_login"
          >
            <template>
              <small>
                <p>
                  Estimados usuarios, les informamos que a partir del Lunes 4 de
                  Mayo todos los nuestros usuarios requerirán de utilizar
                  autenticación de dos pasos para iniciar sesión en plataforma.
                  Los detalles se encuentran especificados en el documento
                  adjunto.
                </p>
                <el-button
                  @click="
                    downloadLocalFile(
                      '/files/Instructivo autenticación multifactor (MFA-2FA).pdf',
                      'Instructivo autenticación multifactor (MFA-2FA).pdf'
                    )
                  "
                  icon="el-icon-download"
                  type="primary"
                  size="small"
                  >Descargar Instructivo (MFA / 2FA)</el-button
                >
              </small>
            </template>
          </el-alert>
          <!-- <br>
        <el-card shadow="always">
          <el-col :span="24">
            <h3 style="font-size: 13px; margin-top: 0px; margin-bottom: 6px">
              INSTRUCTIVOS PARA REVISIÓN
              <br />
            </h3>
            <br />
          </el-col>
          <el-button style="width: 100%; font-size: 10px; font-weight: bold;" type="info" size="small"
            icon="el-icon-tickets" @click="descargarInstructivo('mel')">INSTRUCTIVO
            REVISIÓN MEL</el-button>
          <br /><br />
          <el-button style="width: 100%; font-size: 10px; font-weight: bold;" type="info" size="small"
            icon="el-icon-tickets" @click="descargarInstructivo('spence')">INSTRUCTIVO
            REVISIÓN BHP CHILE Y PAMPA NORTE</el-button>
          <br /><br />
          <el-button style="width: 100%; font-size: 10px; font-weight: bold;" type="danger" size="small"
            icon="el-icon-tickets" @click="descargarManual()">MANUAL DE USUARIO
          </el-button>
        </el-card> -->
        </el-col>
        <el-col :md="8" v-if="!$store.getters.isLoggedIn">
          <el-card shadow="always">
            <div slot="header">
              <h3 style="font-size: 13px; margin-top: 0px; margin-bottom: 0px">
                INGRESO USUARIOS COMPAÑÍA
                <br />
              </h3>
            </div>
            <el-alert
              center
              v-bind:title="error"
              type="error"
              v-if="error"
              show-icon
              :closable="false"
            ></el-alert>

            <el-form
              :model="credentials"
              status-icon
              :rules="rulesLogin"
              ref="formLogin"
            >
              <el-form-item
                style="margin-bottom: 10px"
                prop="rut"
                label="Nombre de usuario"
              >
                <el-input
                  :placeholder="$t('Ingrese nombre de usuario')"
                  v-model="credentials.rut"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password" label="Contraseña">
                <el-input
                  type="password"
                  :placeholder="$t('Ingrese contraseña')"
                  @keyup.native.enter="submit"
                  v-model="credentials.password"
                ></el-input>
              </el-form-item>
            </el-form>
            <center>
              <el-button
                v-loading="isLoading"
                :disabled="
                  credentials.rut === '' || credentials.password === ''
                "
                v-if="!$store.getters.isLoggedIn"
                @click="submit"
                size="medium"
                type="warning"
                >INICIAR SESIÓN
              </el-button>
              <br /><br />
              <el-button
                icon="el-icon-info"
                size="small"
                @click="autocreation()"
                type="info"
                >¿Necesita crear su cuenta?, Realícelo aquí</el-button
              >
              <br /><br />
              <a
                href="#"
                @click="recovery"
                style="color: black; font-size: 13px"
                ><b>¿Ha olvidado su contraseña?</b></a
              >
            </center>
          </el-card>
          <br />
          <br />
        </el-col>
        <el-col :md="8" v-if="!$store.getters.isLoggedIn">
          <el-card shadow="always">
            <div slot="header">
              <el-row>
                <el-col :span="24">
                  <h3
                    style="font-size: 13px; margin-top: 0px; margin-bottom: 0px"
                  >
                    INGRESO USUARIOS COLABORADORES
                    <br />
                  </h3>
                </el-col>
              </el-row>
            </div>
            <el-alert
              center
              v-bind:title="error"
              type="error"
              v-if="error"
              show-icon
              :closable="false"
            ></el-alert>

            <el-form
              v-if="!$store.getters.isLoggedIn"
              :model="credentials_contratista"
              status-icon
              :rules="rulesLoginContratista"
              ref="formLoginContratista"
            >
              <el-form-item
                style="margin-bottom: 10px"
                prop="rut"
                label="Nombre de usuario"
              >
                <el-input
                  :placeholder="$t('Ingrese nombre de usuario')"
                  v-model="credentials_contratista.rut"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password" label="Contraseña">
                <el-input
                  type="password"
                  :placeholder="$t('Ingrese contraseña')"
                  @keyup.native.enter="submitContratista"
                  v-model="credentials_contratista.password"
                ></el-input>
              </el-form-item>
            </el-form>
            <div v-else>
              <center>
                Iniciado como
                <b>{{ username }}</b>
              </center>
              <br />
            </div>
            <center>
              <el-button
                v-loading="isLoading"
                :disabled="
                  credentials_contratista.rut === '' ||
                  credentials_contratista.password === ''
                "
                @click="submitContratista"
                v-if="!$store.getters.isLoggedIn"
                size="medium"
                type="warning"
                >INICIAR SESIÓN
              </el-button>
              <br /><br />
              <el-button
                icon="el-icon-info"
                size="small"
                @click="autocreation()"
                type="info"
                >¿Necesita crear su cuenta?, Realícelo aquí</el-button
              >
              <br /><br />
              <a
                href="#"
                @click="recovery"
                style="color: black; font-size: 13px"
                ><b>¿Ha olvidado su contraseña?</b></a
              >
            </center>
          </el-card>
          <br />
          <br />
        </el-col>
        <el-col :md="14" v-if="$store.getters.isLoggedIn">
          <el-card shadow="always">
            <div slot="header">
              <el-row>
                <el-col :span="16">
                  <h3
                    style="
                      font-size: 16px;
                      margin-top: 10px;
                      margin-bottom: 0px;
                    "
                  >
                    INVENTARIO DE RIESGOS
                    <br />
                  </h3>
                </el-col>
                <el-col :span="8">
                  <img
                    style="float: right"
                    src="../assets/BHP.png"
                    width="90px"
                  />
                </el-col>
              </el-row>
            </div>
            <div>
              Has iniciado sesión como
              <b>{{ username }}</b>
              <br /><br />
              <small
                ><i class="el-icon-info"></i> Para acceder a la plataforma
                Inventario de Riesgos HSE Online debe hacer click en el botón
                <b>IR A LA PLATAFORMA</b></small
              >
              <br /><br /><br />
              <el-button
                style="
                  width: 50%;
                  border-top-right-radius: 0px;
                  border-bottom-right-radius: 0px;
                "
                v-if="$store.getters.isLoggedIn"
                @click="plataforma"
                size="medium"
                type="info"
                >IR A PLATAFORMA
              </el-button>
              <el-button
                style="
                  margin: 0px !important;
                  width: 50%;
                  border-top-left-radius: 0px;
                  border-bottom-left-radius: 0px;
                "
                v-if="$store.getters.isLoggedIn"
                @click="signOut"
                size="medium"
                type="danger"
                >CERRAR SESIÓN</el-button
              >
            </div>
          </el-card>
          <br />
          <br />
        </el-col>
      </el-row>
    </div>

    <el-dialog
      title="Encuesta de percepción Plataforma Inventario de riesgos HSE online"
      width="29%"
      :close-on-click-modal="false"
      :visible.sync="dialogEncuesta"
    >
      <p class="mensaje-encuesta">
        Estimad@ usuario Con el objetivo de cumplir con el proceso de mejora
        continua de la Compañía solicitamos a usted que pueda contestar una
        breve encuesta (9 preguntas). Gracias de antemano por sus valiosos
        comentarios. Saludos Cordiales Safety Club
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="openWindow(encuesta)"
          >Contestar encuesta</el-button
        >
        <el-button type="info" @click="dialogEncuesta = false"
          >Cerrar</el-button
        >
      </span>
    </el-dialog>

    <SupportFooter />
  </div>
</template>

<script>
import axios from "axios";
import SupportFooter from "@/components/SupportFooterDashboard.vue";
import { VueRecaptcha } from "vue-recaptcha";

export default {
  name: "SafetyLogin",
  data() {
    return {
      id_user: "",
      goSessionP: true,
      goSessionC: true,
      siteKey: "6LfIYvIhAAAAAE0oKhMczb-FpqdTMEjwfUUL2wTQ",
      ip: "",
      host: location.host,
      isLoading: false,
      credentials: {
        rut: "",
        password: "",
      },
      credentials_contratista: {
        rut: "",
        password: "",
      },
      error: "",
      rulesLogin: {
        password: [{ validator: this.validatePass, trigger: "blur" }],
        rut: [{ validator: this.validateRUT, trigger: "blur" }],
      },
      rulesLoginContratista: {
        password: [{ validator: this.validatePass, trigger: "blur" }],
        rut: [{ validator: this.validateRUTContratista, trigger: "blur" }],
      },
      dialogEncuesta: false,
      encuesta: "https://forms.office.com/r/T4U3TBNdcK",
    };
  },
  components: {
    SupportFooter,
    VueRecaptcha,
  },
  computed: {
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
  },
  created() {
    this.getIP();
  },
  methods: {
    downloadLocalFile(filePath, fileName) {
      const link = document.createElement("a");
      link.href = filePath;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    config() {
      return {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
    },
    handleErrorP() {
      // Do some validation
    },
    handleSuccessP(response) {
      this.goSessionP = false;
    },
    handleErrorC() {
      // Do some validation
    },
    handleSuccessC(response) {
      this.goSessionC = false;
    },
    async getIP() {
      var response = await axios.get(`https://api.ipify.org?format=json`);
      this.ip = response.data.ip;
    },
    descargarManual() {
      window.location.href =
        "https://gitlab.safetyclub.cl/yonatan.pizarro/manual-bhp/-/raw/master/MAm-HSE-MAN-219%20Manual%20Plataforma%20de%20Inventario%20de%20Riesgos%20HSE%20firmado.pdf?inline=false";
    },
    descargarInstructivo(faena) {
      if (faena === "mel") {
        window.location.href =
          "https://gitlab.safetyclub.cl/yonatan.pizarro/manual-bhp/-/raw/master/Instructivo%20nueva%20funci%C3%B3n%20_Revision%20por%20tarea%20MEL_.pdf?inline=false";
      } else {
        window.location.href =
          "https://gitlab.safetyclub.cl/yonatan.pizarro/manual-bhp/-/raw/master/Instructivo%20nueva%20funci%C3%B3n%20_Revisi%C3%B3n%20por%20tarea%20Pampa%20Norte_.pdf?inline=false";
      }
    },
    async signOut() {
      // reset datos de otros roles
      await this.$store.dispatch("resetEmpresasFaena");
      await this.$store.dispatch("resetAreas");
      await this.$store.dispatch("resetContract");
      await this.$store.dispatch("resetUserAllContracts");
      await this.$store.dispatch("resetUserContractByRole");
      await this.$store.dispatch("latestState", null);
      await this.$store.dispatch("logout", this.$store.getters.user.id_sesion);
      this.$router.push({ name: "homePage" });
    },
    plataforma() {
      this.redirectLoggedUser();
    },
    validatePass(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("Por favor, ingresa tu contraseña")));
      } else {
        callback();
      }
    },
    validateRUT(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("Por favor, ingresa tu nombre de usuario")));
      } else {
        callback();
      }
    },
    validateRUTContratista(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("Por favor, ingresa tu nombre de usuario")));
      } else {
        callback();
      }
    },
    maskEmail(email) {
      return email.replace(/^(.)(.*)(@.*)$/, (match, p1, p2, p3) => {
        const maskedPart = "*".repeat(p2.length);
        return p1 + maskedPart + p3;
      });
    },
    async submit() {
      this.isLoading = true;
      this.id_user = "";
      this.$refs.formLogin.validate(async (valid) => {
        if (valid) {
          this.credentials["ip"] = this.ip;
          var resp = await axios.post(
            `/usuarios/firstLogin`,
            this.credentials,
            this.config()
          );
          if (resp.data.success === true) {
            this.id_user = resp.data.user_id;
            this.$prompt(
              `Ingrese el código que se ha enviado al siguiente email <b><i>${this.maskEmail(
                resp.data.email
              )}</i></b> y oprima el botón <b>continuar</b>`,
              "Autenticación en dos pasos",
              {
                confirmButtonText: "Continuar",
                cancelButtonText: "Cancelar",
                inputPattern: /[0-9]+/,
                dangerouslyUseHTMLString: true,
                inputErrorMessage:
                  "Debe ingresar un código válido para continuar",
                beforeClose: async (action, instance, done) => {
                  if (action === "confirm") {
                    var resp_code = await axios.post(
                      `/usuarios/validateCode`,
                      {
                        user_id: this.id_user,
                        code: parseInt(instance._data.inputValue),
                      },
                      this.config()
                    );
                    if (resp_code.data.success === true) {
                      this.$notify({
                        title: "Información",
                        message: resp_code.data.message,
                        type: "success",
                      });
                      await this.$store.dispatch("login", this.credentials);
                      this.redirectLoggedUser();
                      done();
                    } else {
                      this.$notify.info({
                        title: "Información",
                        dangerouslyUseHTMLString: true,
                        message: resp_code.data.message,
                      });
                    }
                  } else {
                    done();
                  }
                },
              }
            );
            this.isLoading = false;
            return;
          } else {
            this.$notify.info({
              title: "Información",
              dangerouslyUseHTMLString: true,
              message: resp.data.message,
            });
          }
        } else {
          this.isLoading = false;
        }
      });
    },
    async submitContratista() {
      this.isLoading = true;
      this.id_user = "";
      this.$refs.formLoginContratista.validate(async (valid) => {
        if (valid) {
          this.credentials_contratista["ip"] = this.ip;
          var resp = await axios.post(
            `/usuarios/firstLogin`,
            this.credentials_contratista,
            this.config()
          );
          if (resp.data.success === true) {
            this.id_user = resp.data.user_id;
            this.$prompt(
              `Ingrese el código que se ha enviado al siguiente email <b><i>${this.maskEmail(
                resp.data.email
              )}</i></b> y oprima el botón <b>continuar</b>`,
              "Autenticación en dos pasos",
              {
                confirmButtonText: "Continuar",
                cancelButtonText: "Cancelar",
                inputPattern: /[0-9]+/,
                dangerouslyUseHTMLString: true,
                inputErrorMessage:
                  "Debe ingresar un código válido para continuar",
                beforeClose: async (action, instance, done) => {
                  if (action === "confirm") {
                    var resp_code = await axios.post(
                      `/usuarios/validateCode`,
                      {
                        user_id: this.id_user,
                        code: parseInt(instance._data.inputValue),
                      },
                      this.config()
                    );
                    if (resp_code.data.success === true) {
                      this.$notify({
                        title: "Información",
                        dangerouslyUseHTMLString: true,
                        message: resp_code.data.message,
                        type: "success",
                      });
                      await this.$store.dispatch(
                        "login",
                        this.credentials_contratista
                      );
                      this.redirectLoggedUser();
                      done();
                    } else {
                      this.$notify.info({
                        title: "Información",
                        dangerouslyUseHTMLString: true,
                        message: resp_code.data.message,
                      });
                    }
                  } else {
                    done();
                  }
                },
              }
            );
            this.isLoading = false;
            return;
          } else {
            this.$notify.info({
              title: "Información",
              dangerouslyUseHTMLString: true,
              message: resp.data.message,
            });
          }
        } else {
          this.isLoading = false;
        }
      });
    },
    // async submit() {
    //   if (this.goSessionP === false) {
    //     this.isLoading = true;
    //     this.$refs.formLogin.validate(async (valid) => {
    //       if (valid) {
    //         this.credentials["ip"] = this.ip;
    //         const response = await this.$store.dispatch(
    //           "login",
    //           this.credentials
    //         );
    //         if (!response.success) {
    //           this.isLoading = false;
    //           this.$notify.info({
    //             title: "Lo sentimos",
    //             dangerouslyUseHTMLString: true,
    //             message: `
    //             <div style="text-align: left;">
    //             ${response.error}
    //             </div>
    //             `,
    //           });
    //           return;
    //         }
    //         this.redirectLoggedUser();
    //       } else {
    //         this.isLoading = false;
    //       }
    //     });
    //   } else {
    //     this.$notify.info({
    //       title: "Información",
    //       message: "Para continuar debe completar Captcha",
    //     });
    //   }
    // },
    // async submitContratista() {
    //   if (this.goSessionC === false) {
    //     this.isLoading = true;
    //     this.$refs.formLoginContratista.validate(async (valid) => {
    //       if (valid) {
    //         this.credentials["ip"] = this.ip;
    //         const response = await this.$store.dispatch(
    //           "login",
    //           this.credentials_contratista
    //         );
    //         if (!response.success) {
    //           this.isLoading = false;
    //           this.$notify.info({
    //             title: "Información",
    //             message: response.error,
    //           });
    //           return;
    //         }
    //         this.redirectLoggedUser();
    //       } else {
    //         this.isLoading = false;
    //       }
    //     });
    //   } else {
    //     this.$notify.info({
    //       title: "Información",
    //       message: "Para continuar debe completar Captcha",
    //     });
    //   }
    // },
    autocreation() {
      // this.$router.push({ name: "autoCreacionStep0" });
      window.location.href = "https://v2.bhp.lifeon.cl/solicitudes";
    },
    recovery() {
      this.$router.push({ name: "recoveryPassword0" });
    },
    setGoogle() {
      // Setea usuario en Google Analytics
      this.$ga.set("admin", this.$store.getters.role.admin || false);
      this.$ga.set("account_type", this.$store.getters.role.role);
      this.$ga.set("account", this.credentials.rut);
      this.$ga.set(
        "account_name",
        `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`
      );
    },
    async redirectLoggedUser() {
      const haveAccess = await this.$store.dispatch("getRoles");
      if (haveAccess) {
        await this.$store.dispatch("setRole");
        this.setGoogle();
        this.$router.push({ name: "SelectRoles" });
      } else {
        this.$alert(
          "Su tiempo de sesión fue finalizada por inactividad, vuelva ingresar a plataforma.",
          "Información",
          {
            confirmButtonText: "Aceptar",
            callback: async (action) => {
              // reset datos de otros roles
              await this.$store.dispatch("resetEmpresasFaena");
              await this.$store.dispatch("resetAreas");
              await this.$store.dispatch("resetContract");
              await this.$store.dispatch("resetUserAllContracts");
              await this.$store.dispatch("resetUserContractByRole");
              await this.$store.dispatch("latestState", null);
              await this.$store.dispatch(
                "logout",
                this.$store.getters.user.id_sesion
              );
              this.$router.push({ name: "homePage" });
            },
          }
        );
      }
    },
    openWindow(link) {
      window.open(link);
    },
  },
};
</script>

<style scoped>
.intermitente_login {
  animation: infinite resplandorAnimation 2s;
}

@keyframes resplandorAnimation {
  0%,
  100% {
    border: 3px solid red;
  }

  50% {
    border: 3px solid orange;
  }
}

.body {
  background: url("../assets/fondo-login.jpg");
  height: 100vh;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
}

.box-card {
  width: 100%;
  margin: 0 auto;
  min-height: 360px;
}

.login {
  /*position: absolute;*/
  padding: 50px 50px 40px 50px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  max-width: 400px;
  /*top: 40px;
  left: 60px;*/
  /*box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.75);*/
  border: 2px solid #ccc;

  margin: 0 auto;
  margin-top: 80px;
}

.title {
  color: rgb(246, 123, 47);
  font-weight: bold;
  font-size: 25px;
  margin-top: 30px;
  margin-bottom: 10px;
}

.logo-bhp {
  max-width: 100%;
}

.box-card {
  height: 420px !important;
}

.logo-escondida {
  max-width: 100%;
}

.el-alert {
  margin-bottom: 10px;
}

.button {
  width: 100%;
}

@media (max-width: 768px) {
  .login {
    border: none;
    margin-top: 40px;
    margin-right: 10px;
    margin-left: 10px;
    position: static;
    padding: 30px 30px 20px 30px;
  }
}

.mensaje-encuesta {
  white-space: pre-line;
  font-size: 16px;
  padding: 0;
}
</style>
